import { H3 } from "../Text";
import * as dayjs from "dayjs";
import { Tooltip } from "react-tippy";
import { validateArray } from "../../utils/validate";
// import { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";

const TableComplete = (props) => {
  const {
    header,
    data,
    call,
    onClick = () => { },
    height,
    subList,
    buttons,
    titleTable = null,
    editingItemId = null,
    indexSelectedRef
  } = props;

  return (
    <div
      style={{
        maxHeight: height === null ? "" : `${height}px`,
      }}
      className="mx-auto overflow-scroll"
    >
      {
        titleTable &&
        <div className="font-semibold text-center mb-2">
          {titleTable}
        </div>
      }
      <table className="w-full text-sm text-left text-gray-500">
        <thead className="text-[#1d4ed8]">
          <tr>
            {validateArray(header)
              ? header.map((head, index) =>
                head.type === "sticky" ? (
                  <th
                    key={index}
                    scope="col"
                    className={`${index === 0 ? "sticky z-0 left-0" : ""
                      } py-1.5 px-1.5 bg-[#f1f5f9] ${head.sticky ? "sticky right-0 px-2" : ""
                      }`}
                  >
                    {head.listHeader.map((item, j) => (
                      <div key={j} className="whitespace-nowrap">
                        {item.label}
                      </div>
                    ))}
                  </th>
                ) : (
                  <th
                    key={index}
                    scope="col"
                    className={`${index === 0 ? "sticky z-0 left-0 px-6" : ""
                      } py-3 px-2 bg-[#f1f5f9] ${
                      // head.type === 'action'?
                      head.sticky ? "sticky right-0 px-4" : ""
                      // : ''
                      } whitespace-nowrap`}
                  >
                    {head.label}
                  </th>
                )
              )
              : null}
          </tr>
        </thead>
        <tbody>
          {validateArray(data)
            ? data.map((item, index) =>
              subList ? (
                item[subList].map((subItem, j) => {
                  return (
                    <ContainTable
                      key={j}
                      call={call}
                      // item={{ ...subItem, ...item }}
                      item={subItem}
                      header={header}
                      onClick={onClick}
                      buttons={buttons}
                      editingItemId={editingItemId}
                      indexSelectedRef={indexSelectedRef}
                    />
                  );
                })
              ) : (
                <ContainTable
                  key={index}
                  call={call}
                  item={item}
                  header={header}
                  onClick={onClick}
                  buttons={buttons}
                  editingItemId={editingItemId}
                  indexSelectedRef={indexSelectedRef}
                />
              )
            )
            : null}
        </tbody>
      </table>
      {!validateArray(data) && (
        <H3 className="text-center text-gray-500 my-2">La lista esta vacía</H3>
      )}
    </div>
  );
};
const ContainTable = (props) => {
  const { item, header, onClick, call, buttons, editingItemId, indexSelectedRef } = props;
  console.log('Editing ID:', editingItemId, 'Item ID:', item.id); // Para debug
  const isEditing = editingItemId === item.id;
  const { currentRow, setCurrentRow } = useAuth()
  return (
    <tr
      className={`border-b transition-all duration-200 ${isEditing ? 'bg-blue-200 shadow-md' : 'bg-white hover:bg-gray-50'} ${indexSelectedRef && currentRow && currentRow[indexSelectedRef] === item[indexSelectedRef] ? 'bg-green-100 hover:bg-green-200/70 shadow-md' : ''}`}
      style={isEditing ? { backgroundColor: '#bfdbfe' } : undefined}>
      {validateArray(header)
        ? header.map((head, j) =>
          j === 0 ? (
            <th
              key={j}
              scope="row"
              onClick={() => { onClick(item, call); }}
              // className={`sticky left-0 py-4 px-6 font-medium text-gray-900 ${isEditing ? 'bg-blue-200' : 'bg-[#fcfcfc]'} ${indexSelectedRef && currentRow && currentRow[indexSelectedRef] === item[indexSelectedRef] ? 'bg-green-100 hover:bg-green-200/60 shadow-md' : ''}`}
              className={`sticky left-0 py-4 px-6 font-medium text-gray-900  ${indexSelectedRef && currentRow && currentRow[indexSelectedRef] === item[indexSelectedRef] ? 'bg-green-100 hover:bg-green-200/60 shadow-md' : 'bg-[#fcfcfc]'}`}
            >
              <DataType
                value={item[head.name]}
                head={head}
                data={item}
                call={call}
              />
            </th>
          ) : head.type !== "action" ? (
            <td
              key={j}
              className={`${head.sticky ? "sticky right-0 bg-[#f7f7f7]" : "py-2 px-2"
                }`}
              onClick={
                head.disabledOnClick ? () => { } : () => { onClick(item, call); indexSelectedRef && setCurrentRow(item); }
              }
            >
              <DataType
                value={item[head.name]}
                head={head}
                data={item}
                call={call}
                buttons={buttons}
              />
            </td>
          ) : (
            <td
              key={j}
              className={`${head.sticky ? "sticky right-0 min-w-[60px] md:min-w-[120px] xl:min-w-[210px] p-2 bg-[#f7f7f7]" : ""
                }`}
            >
              {validateArray(head.actions) ? (
                <div className="min-w-[60px] md:min-w-[120px] xl:min-w-[210px] grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-2 justify-center items-center">
                  {head.actions.map((act, index) =>
                    act && act.action ? (
                      <div
                        key={index}
                        // className={`${act.color} text-xl cursor-pointer`}
                        className={`${act.color} text-lg w-8 flex justify-center items-center cursor-pointer border-2 rounded-lg border-[#1d4ed830] hover:border-[#1d4ed880] ${act.validate
                          ? item.showButtonJoinPdfs
                            ? ""
                            : "hidden"
                          : ""
                          }`}
                        onClick={() => { act.action(item, call); indexSelectedRef && setCurrentRow(item); }}
                      >
                        <Tooltip
                          // title={act.validate ? (item.showButtonJoinPdfs ? item.showButtonJoinPdfs : act.label) : act.label}
                          title={act.label}
                          position="right"
                          trigger="mouseenter"
                        >
                          {
                            act.iconCondition != null && act.iconCondition !== undefined &&
                            act.iconCondition(item)
                          }
                          <i className={act.icon + ""}></i>
                        </Tooltip>
                      </div>
                    ) : act.builder ? (
                      act.builder(item)
                    ) : null
                  )}
                </div>
              ) : null}
            </td>
          )
        )
        : null}
    </tr>
  );
};

const DataType = (props) => {
  const { value, head, data, call, buttons } = props;

  function validateType() {
    const listData = {
      date:
        value === "0001-01-01T00:00:00" || value === null
          ? "-"
          : dayjs(value).format(head.dateFormat ?? "DD/MM/YYYY HH:mm"),
      custom: head.builder
        ? head.builder(value, head, data, call, buttons)
        : null,
      translate: head.translate ? head.translate[value] : "",
      sticky: (
        <div className="">
          {validateArray(head.listHeader)
            ? head.listHeader.map((list, l) => (
              <div
                key={l}
                className={`${l === 0 ? "font-semibold text-base" : (list.className ?? "font-normal")
                  }`}
              >
                {data[list.name]}
              </div>
            ))
            : null}
        </div>
      ),
    };
    return listData[head.type] || value;
  }
  return <div>{validateType()}</div>;
};

export default TableComplete;
